export default __webpack_public_path__ + "static/media/promos-banner-indon.b151dd60.webp";